/* ============================================================
   PRIME ORGANICS | listicle offer engine (po-ls-confidence, po-ls-reasons)

   One file drives every buy control on both 2026-08 listicle templates:
   tier toggles ([data-ls-tier]), add buttons ([data-ls-add]), price
   mirrors ([data-ls-price], [data-ls-was], [data-ls-save]) and the sticky
   bar. Prices are the REAL wire-verified ladder from the live PDP
   (2026-08-21 + 2026-08-27 products.js): one variant, one selling plan.

   Nothing here invents a price. 2026-09-02: the live offer is the Welcome Kit,
   subscribe = plan 1932918859 at $29.97 vs $59.94 (50% off the first order:
   your bottle plus a free Complete Digestive Probiotic and both guides); one-time = $39.96.
   The listicle CTAs link to the PDP, so these mirrors are parked, but they stay
   in step with the PDP so nothing here can print a stale price. Cart add goes through
   /cart/add.js with the Dawn `sections` trick so the theme's own
   <cart-drawer> re-renders and opens.
   ============================================================ */
(function () {
  'use strict';
  var OFFER = {
    variantId: 42746987577419,
    tiers: {
      sub:  { key: 'sub',  label: 'Subscribe & Save', cents: 2997, wasCents: 5994, pct: 50, plan: 1932918859, note: 'Welcome Kit, then $29.97 every 30 days, cancel anytime' },
      once: { key: 'once', label: 'One-time purchase', cents: 3996, wasCents: 0,    pct: 0,  plan: null,       note: 'one bottle, full price, ships once' }
    },
    pdpUrl: 'https://www.primeorganics.com/products/vaginal-probiotic'
  };
  var money = function (c) { return '$' + (c / 100).toFixed(2); };
  var state = { tier: 'sub', busy: false };
  window.PO_LS = { offer: OFFER, money: money, state: state };

  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function paint() {
    var t = OFFER.tiers[state.tier];
    $all('[data-ls-tier]').forEach(function (el) {
      var on = el.getAttribute('data-ls-tier') === state.tier;
      el.classList.toggle('is-on', on);
      el.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    $all('[data-ls-price]').forEach(function (el) { el.textContent = money(t.cents); });
    $all('[data-ls-was]').forEach(function (el) {
      el.textContent = t.wasCents ? money(t.wasCents) : '';
      el.hidden = !t.wasCents;
    });
    $all('[data-ls-save]').forEach(function (el) {
      el.textContent = t.pct ? 'Save ' + t.pct + '%' : '';
      el.hidden = !t.pct;
    });
    $all('[data-ls-note]').forEach(function (el) { el.textContent = t.note; });
    $all('[data-ls-tierlabel]').forEach(function (el) { el.textContent = t.label; });
  }

  function cartDrawer() { return document.querySelector('cart-drawer'); }

  function openDrawer(json) {
    /* The store runs its own PO drawer (section po-cart-drawer) which exposes
       window.__poCartDrawer / window.openCart and hides Dawn's <cart-drawer>.
       Prefer it; the Dawn sections path is only for a theme without it. */
    var pocd = window.__poCartDrawer;
    if (pocd && typeof pocd.open === 'function') { try { pocd.open(); return; } catch (e) { /* fall through */ } }
    if (typeof window.openCart === 'function') { try { window.openCart(); return; } catch (e) { /* fall through */ } }
    var drawer = cartDrawer();
    if (drawer && typeof drawer.renderContents === 'function' && json && json.sections) {
      try { drawer.renderContents(json); return; } catch (e) { /* fall through */ }
    }
    if (drawer && typeof drawer.open === 'function') {
      document.dispatchEvent(new CustomEvent('cart-drawer:refresh', { bubbles: true }));
      setTimeout(function () { try { drawer.open(); } catch (e) { location.href = '/cart'; } }, 260);
      return;
    }
    location.href = (window.routes && window.routes.cart_url) || '/cart';
  }

  function add(btn) {
    if (state.busy) return;
    var t = OFFER.tiers[state.tier];
    var item = { id: OFFER.variantId, quantity: 1 };
    if (t.plan) item.selling_plan = t.plan;
    var drawer = cartDrawer();
    var body = { items: [item] };
    if (drawer) {
      body.sections = 'cart-drawer,cart-icon-bubble';
      body.sections_url = window.location.pathname;
    }
    state.busy = true;
    var idle = btn ? btn.innerHTML : '';
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.classList.add('is-busy'); }
    var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (json) {
      state.busy = false;
      if (btn) { btn.removeAttribute('aria-busy'); btn.classList.remove('is-busy'); btn.innerHTML = idle; }
      if (json.status && json.status !== 200) {
        var err = document.querySelector('[data-ls-error]');
        if (err) { err.textContent = json.description || json.message || 'Could not add to cart.'; err.hidden = false; }
        return;
      }
      document.dispatchEvent(new CustomEvent('po-ls:added', { bubbles: true, detail: item }));
      openDrawer(json);
    }).catch(function () {
      state.busy = false;
      if (btn) { btn.removeAttribute('aria-busy'); btn.classList.remove('is-busy'); btn.innerHTML = idle; }
      location.href = OFFER.pdpUrl;
    });
  }

  document.addEventListener('click', function (e) {
    var tier = e.target.closest('[data-ls-tier]');
    if (tier) { e.preventDefault(); state.tier = tier.getAttribute('data-ls-tier'); paint(); return; }
    var go = e.target.closest('[data-ls-add]');
    /* 2026-08-28 (Omar): main CTAs and sticky bars go to the live PDP, like the
       refs send every click to their offer page. add() stays for a later switch. */
    if (go) { e.preventDefault(); window.location.href = OFFER.pdpUrl; return; }
    var jump = e.target.closest('[data-ls-jump]');
    if (jump) {
      var target = document.querySelector(jump.getAttribute('data-ls-jump') || '#po-ls-offer');
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    }
  });

  /* sticky bar: on once the sentinel has scrolled above the viewport, off while
     the offer card itself is on screen (no point stacking two buy buttons).
     Plain scroll math on rAF: an IntersectionObserver version silently never
     fired on the live theme (2026-08-27), a scroll listener cannot. */
  function stickyBar() {
    var bar = document.querySelector('[data-ls-sticky]');
    var sentinel = document.querySelector('[data-ls-sticky-after]');
    var offer = document.getElementById('po-ls-offer');
    if (!bar) return;
    if (!sentinel) { bar.classList.add('is-on'); return; }
    var raf = 0;
    var check = function () {
      raf = 0;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var past = sentinel.getBoundingClientRect().top < 0;
      var offerVisible = false;
      if (offer) {
        var r = offer.getBoundingClientRect();
        var visible = Math.min(r.bottom, vh) - Math.max(r.top, 0);
        offerVisible = visible > Math.min(r.height, vh) * 0.15;
      }
      bar.classList.toggle('is-on', past && !offerVisible);
    };
    var queue = function () { if (!raf) raf = requestAnimationFrame(check); };
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue, { passive: true });
    check();
  }
  window.PO_LS.sticky = stickyBar;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { paint(); stickyBar(); });
  else { paint(); stickyBar(); }
})();
